import { BreakpointQueryName, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const wrapper: ThemedFunctor = ({
  theme,
  width,
  $fitMaxAvailableHeight,
}) => css`
  padding: 0 ${theme.remSize[200]};
  max-width: ${width};
  margin: 0 auto;

  ${$fitMaxAvailableHeight && `
    height: 100%;
  `}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    padding: 0 ${theme.remSize[200]};
  }
`;
